if (!customElements.get('quick-view-modal')) {
  customElements.define(
    'quick-view-modal',
    class QuickViewModal extends DrawerComponent {
      constructor() {
        super();

        this._classes = {
          loaded: 'quick-view-loaded',
        };
        this.drawerBody = this.querySelector(this.selector);
      }

      get selector() {
        return '.quick-view__content';
      }

      get sourceSelector() {
        return '#MainProduct-quick-view__content';
      }

      get requiresBodyAppended() {
        return !(Shopify.designMode && this.closest('.section-group-overlay-quick-view'));
      }

      shouleBeShow() {
        const sectionId = this.getProductQuickViewSectionId();
        return typeof sectionId === 'string';
      }

      prepareToShow() {
        super.prepareToShow();
        this.quickview();
      }

      handleAfterShow() {
        super.handleAfterShow();
        document.dispatchEvent(
          new CustomEvent('quick-view:open', {
            detail: { productUrl: this.dataset.productUrl },
          })
        );
      }

      handleAfterHide() {
        super.handleAfterHide();
        const drawerContent = this.querySelector(this.selector);
        drawerContent.innerHTML = '';
        this.classList.remove(this._classes.loaded);
      }

      getProductQuickViewSectionId() {
        let sectionId = FoxTheme.QuickViewSectionId || false;

        if (!sectionId) {
          // Get section id from overlay groups.
          const productQuickView = document.querySelector('.section-group-overlay-quick-view');
          if (productQuickView) {
            sectionId = FoxTheme.utils.getSectionId(productQuickView);
          }

          // Cache for better performance.
          FoxTheme.QuickViewSectionId = sectionId;
        }

        return sectionId;
      }

      quickview(productUrl = null) {
       
        const drawerContent = this.querySelector(this.selector);
        const sectionId = this.getProductQuickViewSectionId();
        const targetUrl = productUrl || this.dataset.productUrl;
        const sectionUrl = `${targetUrl.split('?')[0]}?section_id=${sectionId}`;
        
        // Show loading state
        drawerContent.classList.add('loading');
        
        fetch(sectionUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const productElement = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(this.sourceSelector);

            this.setInnerHTML(drawerContent, productElement.content.cloneNode(true));
            
            // Update the modal's product URL if we're switching products
            if (productUrl) {
              this.dataset.productUrl = productUrl;
            }
            
            // Add swatch click listeners
            this.addSwatchListeners();
            
            FoxTheme.a11y.trapFocus(this, this.focusElement);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            // Remove loading state
            drawerContent.classList.remove('loading');

            drawerContent.scrollTo(0, 0);

            setTimeout(() => {
              this.classList.add(this._classes.loaded);
            }, 300);

            document.dispatchEvent(
              new CustomEvent('quick-view:loaded', {
                detail: { productUrl: targetUrl },
              })
            );
          })
          .catch((e) => {
            console.error(e);
            drawerContent.classList.remove('loading');
          });
      }

      addSwatchListeners() {
        const drawerContent = this.querySelector(this.selector);
        const swatchLinks = drawerContent.querySelectorAll('.swatch-label a[href]');
        
        swatchLinks.forEach(link => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            
            const productUrl = link.getAttribute('href');
            const currentUrl = this.dataset.productUrl.split('?')[0];
            const newUrl = productUrl ? productUrl.split('?')[0] : '';
            
            if (newUrl && newUrl !== currentUrl) {
              // Update the quick-view with the new product
              this.quickview(productUrl);
              
              // Dispatch event for analytics or other purposes
              document.dispatchEvent(
                new CustomEvent('quick-view:swatch-change', {
                  detail: { 
                    previousUrl: this.dataset.productUrl,
                    newUrl: productUrl 
                  },
                })
              );
            }
          });
        });
      }

      setInnerHTML(element, innerHTML) {
        element.innerHTML = '';
        element.appendChild(innerHTML);
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        this.handleAfterHide();
      }
    }
  );
}
